export const stats = {
  main_title: "Statistik",
  overview: "Överblick",
  performed_activites: "utförda aktiviteter",
  total_activities: "Schemalagda aktiviteter",
  whole_year: "Helår",
  period: "Period",
  year: "År",
  my_homes: "Mina boenden",
  homes: "Boenden",
  users: "Brukare",
  objectives: "Målsättningar",
  x_times: " gånger",
  staff: "Personal (avcheckning)",
  per_day: "/dag",
  per_day_template: "{1} aktiviteter avcheckade på {2} dagar = {3} per / dag",
  day: "day",
  days: "days",
  box_performed: "Utförda",
  box_unable: "Ej möjligt",
  box_not_performed: "Ej utförda",
  performed: "Utförd",
  unable: "Ej möjligt",
  not_performed: "Ej utförd",
  activites: "Aktiviteter",
  wellbeing: "Mående",
  loading_stats: "Laddar statistik...",
  statistics_subtitle: "HR-målsättningar och rutiner",
  hr_only_info: "HR-statistik är endast tillgänglig i HR-läge.",
  select_organization: "Välj organisation",
  select_organization_to_view: "Välj en organisation för att visa data.",
  hr_goals: "Målstatistik",
  hr_routines: "Rutinstatistik",
  no_statistics_data: "Ingen statistikdata tillgänglig.",
  error_loading_hr_statistics: "Kunde inte ladda HR-statistik.",
  error_loading_organizations: "Kunde inte ladda organisationer.",
  kpi_total_employees: "Totala medarbetare",
  kpi_active_this_period: "Aktiva denna period",
  kpi_avg_goal_completion_rate: "Genomsnittlig måluppfyllelse",
  kpi_avg_routine_completion_rate: "Genomsnittlig rutinföljning",
  kpi_total_coins_awarded: "Totalt intjänade mynt",
  employee: "Medarbetare",
  goal_count: "Mål",
  avg_completion_rate: "Genomsnittlig fullföljande",
  total_routine_dates: "Rutin-datum",
  completed_routine_dates: "Genomförda datum",
  routine_count: "Rutiner",
  total_dates: "Totala datum",
  completed_dates: "Genomförda datum",
  completion_rate: "Fullföljande",
  tab_company: "Företagsdata",
  tab_individual: "Individuell",
};
